import React from "react";

const PrelimsSyllabusMain = () => {
  return (
    <div className="container my-5" style={{ paddingBottom: "70px" }}>
      {/* Prelims Exam Syllabus */}
      <div className="mb-4">
        <p>
          The Civil Services Preliminary exam consists of two compulsory papers
          of 200 marks each: General Studies Paper I and General Studies Paper
          II (CSAT). The questions are multiple-choice and objective-type. The
          marks in prelims will not be counted for final ranking but are used to
          qualify for the main exam.
        </p>
      </div>

      {/* Paper I */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">
          Prelims Paper I: General Studies
        </h3>
        <p>
          <strong>Marks:</strong> 200 | <strong>Duration:</strong> 2 hours |{" "}
          <strong>Counted for Mains Selection</strong>
        </p>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            Current events of national and international importance.
          </li>
          <li className="list-group-item">
            History of India and Indian National Movement.
          </li>
          <li className="list-group-item">
            Indian and World Geography - Physical, Social, Economic Geography of
            India and the World.
          </li>
          <li className="list-group-item">
            Indian Polity and Governance - Constitution, Political System,
            Panchayati Raj, Public Policy, Rights Issues, etc.
          </li>
          <li className="list-group-item">
            Economic and Social Development - Sustainable Development, Poverty,
            Inclusion, Demographics, Social Sector initiatives, etc.
          </li>
          <li className="list-group-item">
            General issues on Environmental Ecology, Bio-diversity and Climate
            Change – that do not require subject specialization.
          </li>
          <li className="list-group-item">General Science.</li>
        </ul>
      </div>

      {/* Paper II */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">Prelims Paper II: CSAT</h3>
        <p>
          <strong>Marks:</strong> 200 | <strong>Duration:</strong> 2 hours |{" "}
          <strong>Qualifying with 33% Marks</strong>
        </p>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">Comprehension.</li>
          <li className="list-group-item">
            Interpersonal skills including communication skills.
          </li>
          <li className="list-group-item">
            Logical reasoning and analytical ability.
          </li>
          <li className="list-group-item">
            Decision-making and problem-solving.
          </li>
          <li className="list-group-item">General mental ability.</li>
          <li className="list-group-item">
            Basic numeracy (numbers and their relations, orders of magnitude,
            etc.) - Class X level.
          </li>
          <li className="list-group-item">
            Data interpretation (charts, graphs, tables, data sufficiency, etc.)
            - Class X level.
          </li>
        </ul>

        <strong>Note:</strong>

        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li>
            Paper II is a qualifying paper with a minimum of 33% marks required.
          </li>
          <li>The questions are multiple-choice and objective type.</li>
          <li>
            It is mandatory to appear in both papers; failure to do so results
            in disqualification.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PrelimsSyllabusMain;
